module.exports = __webpack_public_path__ + "static/img/2021.02915e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2021.jpg
// module id = lFiM
// module chunks = 1